import { render } from "./importSubject.vue?vue&type=template&id=7fbe2372&scoped=true"
import script from "./importSubject.vue?vue&type=script&lang=js"
export * from "./importSubject.vue?vue&type=script&lang=js"

import "./importSubject.vue?vue&type=style&index=0&id=7fbe2372&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbe2372"]])

export default __exports__